"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Speedtrap = exports.GoogleAnalytics = exports.analyticsEvent = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* Analytics */

/* Component to keep analytics utility functionality centralised */

/**
 * Checks if Google Analytics exists on the page
 *
 * @return {boolean}
 */
var GoogleAnalytics = function GoogleAnalytics() {
  return window !== undefined && window.ga !== undefined && typeof window.ga === 'function';
};
/**
 * Checks if the correct Speedtrap methods exist on the page
 *
 * @return {boolean}
 */


exports.GoogleAnalytics = GoogleAnalytics;

var Speedtrap = function Speedtrap() {
  return window !== undefined && window.SDCSAclick !== undefined && typeof window.SDCSAclick === 'function' && window.SDCSAevent !== undefined && typeof window.SDCSAevent === 'function' && window.SDCSAformsubmit !== undefined && typeof window.SDCSAformsubmit === 'function' && window.SDCSAtextchange !== undefined && typeof window.SDCSAtextchange === 'function';
};
/**
 * Checks if the string passed is empty
 *
 * @param {string} - A string param
 * @return {boolean}
 */


exports.Speedtrap = Speedtrap;

var isEmptyString = function isEmptyString(string) {
  return typeof string !== 'string' || string.trim() === '';
};
/**
 * Sends a Google Analytics event to the window.ga method
 *
 * @param {object} - An event of data
 * @return {boolean}
 */


var handleGoogleAnalyticsEvent = function handleGoogleAnalyticsEvent(event) {
  if (isEmptyString(event.category) || isEmptyString(event.action) || isEmptyString(event.label)) {
    console.error('AnalyticsEvent: Google Analytics requires object with string values for category, action and label');
    return false;
  }

  window.ga('send', 'event', event.category, event.action, event.label);
  return true;
};
/**
 * Sends a Speedtrap event to the window.SDCSAclick method
 *
 * @param {object} - An event of data
 * @return {boolean}
 */


var handleSpeedtrapEvent = function handleSpeedtrapEvent(event) {
  if (event.data === undefined || _typeof(event.data) !== 'object') {
    console.error('AnalyticsEvent: Speedtrap requires an event object with a data object key');
    return false;
  }

  window.SDCSAclick(_objectSpread(_objectSpread({}, event.data), {}, {
    type: 'click'
  }));
  return true;
};
/**
 * Sends a Google Analytics/ Speedtrap event if the platform is defined and the event object is valid
 *
 * @param {object} event - An event of data
 * @return {boolean/function(event)} A boolean or invoked event handler function/s (handleGoogleAnalyticsEvent, handleSpeedtrapEvent)
 * @example
 *     analyticsEvent({
			category: 'GA category',
			action: 'GA action',
			label: 'GA Label',
			data: {
				name: 'Speedtrap name',
				id: `Speedtrap ID`,
			},
			send: {
				googleAnalytics: true,
				speedtrap: true,
			},
		})
 */


var analyticsEvent = function analyticsEvent(event) {
  var GoogleAnalyticsExists = GoogleAnalytics();
  var SpeedtrapExists = Speedtrap();

  if (!GoogleAnalyticsExists && !SpeedtrapExists) {
    console.error('AnalyticsEvent: no analytics platform detected');
    return false;
  }

  if (_typeof(event) !== 'object') {
    console.error('AnalyticsEvent: requires object as parameter');
    return false;
  }

  if (event.send !== undefined && (event.send.googleAnalytics === false && event.send.speedtrap === false || event.send.googleAnalytics === false && event.send.speedtrap === undefined)) {
    console.error('AnalyticsEvent: no platform set in send object');
    return false;
  }

  if (GoogleAnalyticsExists && SpeedtrapExists && event.send !== undefined && event.send.googleAnalytics === true && event.send.speedtrap === true) {
    return handleGoogleAnalyticsEvent(event) && handleSpeedtrapEvent(event);
  }

  if (GoogleAnalyticsExists && (event.send === undefined || event.send.googleAnalytics === true)) {
    return handleGoogleAnalyticsEvent(event);
  }

  if (SpeedtrapExists && event.send !== undefined && event.send.speedtrap === true) {
    return handleSpeedtrapEvent(event);
  }

  return true;
};

exports.analyticsEvent = analyticsEvent;